export const createVigLink = (url, type) => {
	const encodeLink = encodeURIComponent(url)
	const key = "30cb7483bab3e65ae4148f3b113252ce"
	
	return `http://redirect.viglink.com?u=${encodeLink}&key=${key}&cuid=web_${type}`
}
